<template>
	<button type="button" class="mdc-button mdc-button--outlined" @click="onAdd">
		+ {{ addButtonLabel }}
	</button>
</template>

<script>
import { capitalize } from '../utils/helpers';

export default {
	name: 'AddButton',
	props: {
		addKey: String,
		groupKey: String,
		level: Number
	},
	computed: {
		addButtonLabel() {
			const customKey = `addPerson${capitalize(this.groupKey)}${this.level}`;
			const label = this.$t(customKey) || this.$t('addPerson');

			return label;
		}
	},
	methods: {
		onAdd() {
			this.$store.commit('addConfiguratorItemPart', {
				key: this.addKey
			});
		}
	}
};
</script>

<style>
@import url('../assets/css/variables.css');
</style>
